import React, { useEffect } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { Toaster, ToastBar, toast } from 'react-hot-toast';
import Header from "./components/Header/Header";
import BookingList from "./components/BookingList/BookingList";
import Registration from "./components/Registration/Registration";
import RecoverPassword from "./components/RecoverPassword/RecoverPassword";
import CheckEmailForm from "./components/CheckEmailForm/CheckEmailForm";
import Preloader from "./components/Preloader/Preloader";
import WeekBooking from "./components/WeekBooking/WeekBooking";
import Filters from "./components/Filters/Filters";
import { estAction } from "./redux/actions";
import UserBar from "./components/UserBar/UserBar";
import { checkHashSagaAction } from "./redux/sagaActions";
import Schedule from "./components/Schedule/Schedule";
import MyReserves from "./components/MyReserves/MyReserves";
import MobileMenu from "./components/MobileMenu/MobileMenu";
import ChoiceAddressForm from "./components/ChoiceAddressForm/ChoiceAddressForm";

const App = () => {
    const dispatch = useDispatch();

    const app_start = useSelector(state => state.app_start);
    const loading = useSelector(state => state.loading);
    const registration_form = useSelector(state => state.registration_form);
    const recovery_password_form = useSelector(state => state.recovery_password_form);
    const check_email_form = useSelector(state => state.check_email_form);
    const booking = useSelector(state => state.booking);
    const filters = useSelector(state => state.filters);
    const schedule = useSelector(state => state.schedule);
    const my_reserves = useSelector(state => state.my_reserves);
    const choice_address_form = useSelector(state => state.choice_address_form);

    // Если открыли iframe, сохраняем slug & est
    useEffect(() => {
        let slug, est;
        if (process.env.NODE_ENV === 'development') {
            slug = 'fitness';
            est = 1;
        }
        else {
            let path = window.location.href;
            path = path.replace('https://alga.by/fitness_widget?sl=', '');

            [slug, est] = path.split('&est=');
            // Удаление модификаций ссылки
            est = est.replace(/&(.+)$/, '');
        }

        dispatch(estAction({
            slug,
            id: est
        }));

        // Проверяем хэш пользователя
        dispatch(checkHashSagaAction());

    }, []);

    useEffect(() => {
        if (!booking.reserves.length) return;

        let height = 150;
        if (document.querySelector('.week__days')) {
            height = document.querySelector('.week__days').scrollHeight + 70;
        }
        else if (document.querySelector('.list')) {
            height = document.querySelector('.list').scrollHeight + 70;
        }


        window.parent.postMessage(height, '*');
    }, [booking.reserves]);

    if (!app_start) {
        return (
            <Preloader/>
        );
    }

    return (
        <>
            <Toaster
                position={ 'top-right' }
                toastOptions={{
                    success: { duration: 5000 },
                    error: { duration: 5000 }
                }}
            >
                {(t) => {
                    return (
                        <div
                            className="w-auto cursor-pointer toast__custom-font"
                            onClick={() => toast.dismiss(t.id)}
                        >
                            <ToastBar toast={ t } />
                        </div>
                    );
                }}
            </Toaster>
            {
                loading ? <Preloader/> : false
            }
            { filters.open && <Filters/> }
            <MobileMenu/>
            { choice_address_form.open && <ChoiceAddressForm/> }
            <div className={ `content ${ booking.appearance === 'desktop' ? 'content--desktop' : 'content--mobile' }` }>
                <UserBar/>
                { registration_form.open && <Registration/> }
                { recovery_password_form.open && <RecoverPassword/> }
                { check_email_form.open && <CheckEmailForm/> }
                <Header/>
                { schedule.open && <Schedule/> }
                { my_reserves.open && <MyReserves/> }
                {
                    booking.appearance === 'mobile'
                    ?
                        <BookingList/>
                    :
                        <WeekBooking/>
                }
            </div>
        </>
    );
};

export default App;
